<template>
  <div class="course-container">
    <div class="course-container-header">

      <img class="header-bg" v-if=" details.logo" :src="imageUrl + details.logo" alt="">

      <div class="header-opt"></div>

      <div class="header-center">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/home' }">
            <span style="color: #FFFFFF">首页</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="color: #999999">课程列表</span> </el-breadcrumb-item>
        </el-breadcrumb>

        <div class="course-title">
          <h2>{{details.name || ''}}</h2>
          <p></p>
        </div>
      </div>
    </div>

    <div class="course-menu">
      <ul class="flex flex_align-items">
        <li class="course-menu-item pointer active">章节</li>
      </ul>
    </div>

    <div class="main" style="margin-top: 30px">
      <router-view :courseId="details.id"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeCourse",
  data() {
    return {
      details: {},
      imageUrl: this.$API.BASE_URL
    }
  },
  created() {
    this.$get(this.$API.COURSE_DETAIL, {
      courseId: this.$route.query.courseId,
    }).then(res => {
      this.details = res.data
    })
  }
}
</script>

<style scoped lang="scss">
.course-container {
  &-header {
    position: relative;

    .header-opt {
      background: rgba(0,0,0,0.6);
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;

    }

    .header-bg {
      position: absolute;
      top: 0;
      object-fit: cover;
      filter: blur(8px);
    }

    .header-center{
      position: relative;
      z-index: 9;
      width: 1400px;
      margin: 0 auto;
      padding: 30px 0;
      color: #a3aaae;

      .course-title {
        margin: 30px 0;
        color: #FFFFFF;

      }
    }
  }

  .course-menu {
    box-shadow: 0 4px 8px 0 rgb(28 31 33 / 10%);

    ul {
      width: 1400px;
      margin: 0 auto;
      height: 60px;
      line-height: 60px;
    }

    &-item {
      padding: 0 $spacing-cols-lg;
    }

    .active {
      color: #409eff;
      position: relative;
      &:after {
        content: "";
        position: absolute;
        width: 20px;
        height: 3px;
        background: #409eff;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
